import React from 'react';
import classNames from 'classnames';
import { buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import AutoAllocateAllButton
  from 'Views/Page/Content/Templates/WhatIfTemplate/Content/RightSide/BottomPart/DetailPicker/Details/Content/AutoAllocateAllButton';
import { hasRelationship } from 'Helpers/Affordances';
import fr from 'facet-rest';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import PropTypes from 'prop-types';
import {
  FDBox, FDHeadlineText, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';

const useStyles = buildUseStyles('TableTitle', (theme => ({
  root: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: theme.spacing(2),
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    position: 'sticky', // <---- Prevents Table title from scrolling-X with table content
    left: 0,
  },
  rootHidden: {
    display: 'none',
  },
  title: {
    marginLeft: theme.spacing(1),
  },
})));

const TableTitle = ({
  showButton, tableName, autoAllocateAllUrl, onSubmit, saving,
}) => {
  const classes = useStyles();

  const { pageContentResource } = usePageContentContext();

  return (
    <Box
      className={classNames(classes.root, {
        [classes.rootHidden]: !showButton,
      })}
    >
      <FDStack direction={'row'} spacing={1} alignItems={'center'}>
        {tableName && (
        <FDBox padding={2}>
          <FDHeadlineText value={tableName} color={'textSecondary'} size={'sm'} />
        </FDBox>
        )}
        {(showButton && (hasRelationship(pageContentResource, fr.relationships.autoAllocateOutcome.name) || !!autoAllocateAllUrl)) ? (
          <AutoAllocateAllButton autoAllocateUrl={autoAllocateAllUrl || pageContentResource.relationship(fr.relationships.autoAllocateOutcome.name).link('related').url()} />
        ) : null}
        {(onSubmit && (
        <FDPrimaryActionButton
          onClick={() => onSubmit()}
          loading={saving}
          label={'Save Changes'}
          size={'sm'}
        />
        ))}
      </FDStack>
    </Box>
  );
};


TableTitle.defaultProps = {
  tableName: null,
  autoAllocateAllUrl: null,
  onSubmit: null,
  saving: false,
};

TableTitle.propTypes = {
  showButton: PropTypes.bool.isRequired,
  tableName: PropTypes.string,
  autoAllocateAllUrl: PropTypes.string,
  onSubmit: PropTypes.func,
  saving: PropTypes.bool,
};

export default TableTitle;
